import { Component, createRef } from 'react';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import classNames from 'classnames/bind';

import WatchlistTopicsList from '../WatchlistTopicsList';
import WatchlistRightBarHeader from './WathclistRightBarHeader';
import PiwikContext from '../../../services/piwikContext';
import withComponentName from '../../../decorators/withComponentName';
import SentimentAnalysis from '../../SentimentAnalysis';

import permissionsDecorator from '../../../decorators/permissionsDecorator';

import Styles from './styles.module.scss';

const cx = classNames.bind(Styles);

class WatchlistRightBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isRightBarFixed: false,
      topCSS: 0,
      holderHeight: 'calc(100% - 40px)',
    };
    autoBind(this);
    this.rightBarRef = createRef();
    this.rightBarInnerRef = createRef();
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll, { passive: true });
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    const { statePromo, permissionsInitialized, showSuggestion } = this.props;
    const { height } = statePromo;
    const rightBarTop = this.rightBarRef.current.getBoundingClientRect().top;
    const mainScrollUpButtom = document.querySelector('[id^="common-footer"]');
    const rect = mainScrollUpButtom.getBoundingClientRect();
    const windowHeight = (window.innerHeight || document.documentElement.clientHeight);
    const heightDiff = windowHeight - rect.top;
    const extraPixel = Number.isInteger(heightDiff) ? 0 : 1;
    let holderHeight = 31;
    if (permissionsInitialized && showSuggestion) {
      const childHeight = this.rightBarInnerRef.current.firstElementChild.offsetHeight;
      holderHeight += childHeight + 16;
    }
    this.setState({
      isRightBarFixed: (rightBarTop - height) <= 0,
      topCSS: heightDiff > 0 ? heightDiff + extraPixel : 0,
      holderHeight: `calc(100% - ${holderHeight}px)`,
    });
  }

  checkSearchBar() {
    const { openedSearchbarType } = this.props;

    return openedSearchbarType.some((searchbarType) => (
      searchbarType.opened
      && (searchbarType.type === 'createWatchlistsSearchbar' || searchbarType.type === 'editWatchlistsSearchbar')
    ));
  }

  render() {
    const {
      client,
      isFilingsPage = false,
      statePromo,
      token,
      isChatbotOpened,
      wlPageLoadingStep,
    } = this.props;
    const { isRightBarFixed, topCSS, holderHeight } = this.state;
    const rightBarClass = cx('right_bar_wrapper', { fixed: isRightBarFixed }, { 'chatbot-opened': isChatbotOpened });
    const { height } = statePromo;
    const countTop = `${height}px`;
    const isSearchBarActive = this.checkSearchBar();

    return (
      <div className={Styles.right_bar_holder} ref={this.rightBarRef}>
        <div
          className={rightBarClass}
          style={{ top: countTop, bottom: `${topCSS}px` }}
          ref={this.rightBarInnerRef}
        >
          {wlPageLoadingStep !== 'LOADING_WL' && (
            <WatchlistRightBarHeader />
          )}
          <PiwikContext.Consumer>
            {(value) => (
              <div
                className={Styles.watchlist_topics_list_holder}
                style={{
                  overflow: isSearchBarActive ? 'unset' : 'auto',
                  height: holderHeight,
                }}
              >
                <WatchlistTopicsList
                  client={client}
                  piwikEnabled={value.piwikEnabled}
                  isFilingsPage={isFilingsPage}
                />
                {
                  token ? (
                    <div>
                      <SentimentAnalysis
                        isWatchlistPage
                      />
                    </div>
                  ) : null
                }
              </div>
            )}
          </PiwikContext.Consumer>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({
  promobar,
  searchReducers,
  subscriptions,
  watchlistReducer,
  chatbot,
}) => {
  const { permissions, permissionsInitialized } = subscriptions;
  const { activeWatchlistTopics } = watchlistReducer;
  const { max_watchlist_size: maxWatchlistSize } = permissions;

  return {
    statePromo: promobar,
    openedSearchbarType: searchReducers.openedSearchbarType,
    permissionsInitialized,
    showSuggestion: activeWatchlistTopics.length >= maxWatchlistSize,
    token: watchlistReducer.userToken,
    isChatbotOpened: chatbot.isChatbotOpened,
    wlPageLoadingStep: watchlistReducer.wlPageLoadingStep,
  };
};

export default withComponentName(
  connect(mapStateToProps, null)(permissionsDecorator(WatchlistRightBar)),
);
